import React from 'react';
import ButtonAddToCart from './ButtonAddToCart';
import ButtonFirmware from './ButtonFirmware';
import ButtonLearnMore from './ButtonLearnMore';
import ButtonPortal from './ButtonPortal';
import If from './If';

interface ActionButtonProps {
  productType: string;
  learnMore: string;
  id: string;
  pid: string;
  available: boolean;
  name: string;
  isLegacy: boolean;
}
export default function ActionButton(props: ActionButtonProps) {
  const isExternal =
    props.productType === 'Sample Pack' || props.productType === 'Reason';

  const portal = props.productType === 'Free Software';
  const firmware = props.productType === 'Firmware';

  const internal = !isExternal && !portal && !firmware;

  return (
    <>
      <If value={internal}>
        <ButtonAddToCart
          name={props.name}
          id={props.id}
          pid={props.pid}
          availableForSale={props.available}
          isLegacy={props.isLegacy}
        />
      </If>
      <If value={isExternal}>
        <ButtonLearnMore link={props.learnMore} />
      </If>
      <If value={firmware}>
        <ButtonFirmware link='/portal/firmware' />
      </If>
      <If value={portal}>
        <ButtonPortal />
      </If>
    </>
  );
}
